const PaymentMethod = ({text, onClick=()=>{}, style={}}) => {
	return (
		<button style={style} onClick={onClick}>{text}</button>
	);
};

export default PaymentMethod;